module.exports = {
  "defaultCurrency": "CHF",
  "currencies": [
    {
      "id": 6,
      "code": "CHF",
      "name": "₣CHF",
      "change_store": false,
      "store": null,
      "base_currency": null
    }
  ]
}